export const drawerWidth = 300;
export const AppBarHeight = 120;
export const SmHeaderHeight = 80;
export const LgHeaderHeight = 112;
